/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WizardStep from 'shared/ui/components/WizardStep.vue';
import InteractivityOptions from 'shared/ui/components/live-sessions/settings/InteractivityOptions.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    components: {
        InteractivityOptions,
        WizardStep,
        BaseInput,
        Toggler
    },

    extends: WizardStep,

    watch: {
        'form.interactivityOptions.interprefyEnabled': function(next, prev) {
            if (prev !== null && prev !== undefined && next === false) {
                this.$nextTick(() => this.validate());
            }
        }
    },

    methods: {
        /**
         * react to change to interactivity options in child component
         *
         * @param {object} payload
         * @param {string} payload.field object field to change
         * @param {any} payload.value new value to store
         */
        change({ field, value }) {
            this.form.interactivityOptions = {
                ...this.form.interactivityOptions,
                [field]: value,
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"workspace-form",attrs:{"tag":"form"}},[_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"interprefy","on-label":"live_sessions.form.interprefy","off-label":"live_sessions.form.interprefy"},model:{value:(_vm.form.interactivityOptions.interprefyEnabled),callback:function ($$v) {_vm.$set(_vm.form.interactivityOptions, "interprefyEnabled", $$v)},expression:"form.interactivityOptions.interprefyEnabled"}},[(_vm.form.interactivityOptions.interprefyEnabled)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"slim":true,"rules":_vm.form.interactivityOptions.interprefyEnabled ? 'required' : '',"name":"interprefy_project_id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('live_sessions.form.interprefy_project_id'),"type":"text","name":"interprefy_project_id","errors":errors},model:{value:(_vm.form.interactivityOptions.interprefyProjectId),callback:function ($$v) {_vm.$set(_vm.form.interactivityOptions, "interprefyProjectId", $$v)},expression:"form.interactivityOptions.interprefyProjectId"}})]}}],null,false,2572767810)})],1):_vm._e()])],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"who_is_watching","on-label":"live_sessions.form.who_is_watching","off-label":"live_sessions.form.who_is_watching"},model:{value:(_vm.form.interactivityOptions.whoIsWatchingEnabled),callback:function ($$v) {_vm.$set(_vm.form.interactivityOptions, "whoIsWatchingEnabled", $$v)},expression:"form.interactivityOptions.whoIsWatchingEnabled"}})],1),_c('interactivity-options',{attrs:{"show-polls-option":"show-polls-option","show-qna-moderation-option":"show-qna-moderation-option","show-interprefy-option":"show-interprefy-option","show-claps-option":"show-claps-option"},on:{"change":_vm.change},model:{value:(_vm.form.interactivityOptions),callback:function ($$v) {_vm.$set(_vm.form, "interactivityOptions", $$v)},expression:"form.interactivityOptions"}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Interactivity.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__